import tags from "../../components/tags";
import { icons } from "../../components/html";
import { statusCodes } from "../../components/responses";

export default {
  "/user": {
    get: {
      tags: [tags.sizeIdAccount],
      summary: "User profile",
      description: `${icons.u}
      Return user profile of currently logged user.`,
      parameters: [{ $ref: "#/components/parameters/acceptsLanguages" }],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/user"
              }
            }
          }
        },
        ...statusCodes
      },
      security: [{ user: [] }]
    }
  }
};
